var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import _ from "underscore";
import RuntimePersonEndpoints from "src/shared/api/person/RuntimePersonEndpoints";
import uploadPersonAssetService from "src/shared/upload-person-asset-service";
import ProgramEndpoints from "src/shared/api/program/ProgramEndpoints";
import { reactive } from "vue";
import { toPromise } from "src/shared/api/promise";
import Person from "./model/Person";
import { personChangeEvent } from "../event-bus/person";
const doUpload = (personId, file) => {
    return new Promise((resolve, reject) => {
        uploadPersonAssetService
            .uploadPersonAsset(personId, file)
            .then((response) => {
            resolve(response);
        })
            .fail(() => reject());
    });
};
function getDefaultProgramDomain(programDomains) {
    return (_.findWhere(programDomains, {
        redirect_program_id: null,
        is_extole_domain: false,
    }) ||
        _.findWhere(programDomains, {
            redirect_program_id: null,
        }) ||
        {}).domain;
}
const lookupDefaultProgramDomain = () => {
    return new Promise((resolve, reject) => {
        ProgramEndpoints.getPrograms()
            .then((programResponses) => {
            const defaultProgramDomain = getDefaultProgramDomain(programResponses);
            if (defaultProgramDomain) {
                resolve(defaultProgramDomain);
            }
            else {
                reject();
            }
        })
            .fail(() => {
            reject();
        });
    });
};
const calculateProfilePictureUrl = (personId, asset) => __awaiter(void 0, void 0, void 0, function* () {
    const programDomain = yield lookupDefaultProgramDomain();
    return `https://${programDomain}/api/v4/persons/${personId}/assets/${asset.id}/download`;
});
const toPersonRequest = (person) => {
    return {
        email: person.email,
        first_name: person.first_name,
        last_name: person.last_name,
        partner_user_id: person.partner_user_id,
        blocked: person.blocked,
    };
};
export const usePersonStore = defineStore("personStore", () => {
    const state = reactive({
        persons: {},
        person_parameters: {},
    });
    const setPersons = (personResponses) => {
        return _.map(personResponses, (response) => {
            const person = new Person(response);
            state.persons[person.person_id] = person;
            return person;
        });
    };
    const fetchPersons = (parameters) => __awaiter(void 0, void 0, void 0, function* () {
        const personResponses = yield toPromise(RuntimePersonEndpoints.get(parameters));
        return setPersons(personResponses);
    });
    const fetchPerson = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        const { personId } = payload;
        const personResponse = yield toPromise(RuntimePersonEndpoints.getPerson(personId));
        const [person] = setPersons([personResponse]);
        return person;
    });
    const updatePerson = (personUpdate) => __awaiter(void 0, void 0, void 0, function* () {
        const personResponse = yield toPromise(RuntimePersonEndpoints.update(personUpdate.person_id, toPersonRequest(personUpdate)));
        const [person] = setPersons([personResponse]);
        personChangeEvent.emit({ personId: person.person_id });
        return person;
    });
    const createPerson = (personCreate) => __awaiter(void 0, void 0, void 0, function* () {
        const personResponse = yield toPromise(RuntimePersonEndpoints.create(toPersonRequest(personCreate)));
        const [person] = setPersons([personResponse]);
        return person;
    });
    const uploadPicture = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        const { personId } = payload;
        const asset = yield doUpload(personId, payload.file);
        const pictureUrl = yield calculateProfilePictureUrl(personId, asset);
        const personResponse = yield toPromise(RuntimePersonEndpoints.update(personId, {
            picture_url: pictureUrl,
        }));
        setPersons([personResponse]);
    });
    const getPerson = (personId) => {
        return state.persons[personId];
    };
    personChangeEvent.on(({ personId }) => {
        fetchPerson({
            personId,
        });
    });
    return {
        state,
        fetchPersons,
        fetchPerson,
        updatePerson,
        createPerson,
        uploadPicture,
        getPerson,
    };
});
